export const PLAYGROUND_ENABLED_KITS = [
  "advanced_table",
  "avatar",
  "background",
  "badge",
  "body",
  "bread_crumbs",
  "button_toolbar",
  "button",
  "caption",
  "card",
  "checkbox",
  "circle_icon_button",
  "collapsible",
  "contact",
  "container",
  "copy_button",
  "currency",
  "dashboard_value",
  "date_picker",
  "date_range_inline",
  "date_range_stacked",
  "date_stacked",
  "date_time_stacked",
  "date_time",
  "date_year_stacked",
  "date",
  "detail",
  "dialog",
  "distribution_bar",
  "draggable",
  "dropdown",
  "empty_state",
  "file_upload",
  "filter",
  "fixed_confirmation_toast",
  "flex",
  "form_group",
  "form_pill",
  "full_screen",
  "hashtag",
  "highlight",
  "home_address_street",
  "icon_circle",
  "icon_stat_value",
  "icon_value",
  "icon",
  "image",
  "label_pill",
  "label_value",
  "legend",
  "layout",
  "link",
  "list",
  "loading_inline",
  "map",
  "message",
  "multi_level_select",
  "multiple_users_stacked",
  "multiple_users",
  "nav",
  "online_status",
  "overlay",
  "pagination",
  "passphrase",
  "pb_bar_graph",
  "pb_circle_chart",
  "pb_gauge_chart",
  "pb_line_graph",
  "person_contact",
  "person",
  "phone_number_input",
  "pill",
  "popover",
  "progress_pills",
  "progress_simple",
  "progress_step",
  "radio",
  "rich_text_editor",
  "section_separator",
  "select",
  "selectable_card_icon",
  "selectable_card",
  "selectable_icon",
  "title_count",
  "title_detail",
  "title",
  "selectable_list",
  "skeleton_loading",
  "source",
  "star_rating",
  "stat_change",
  "stat_value",
  "table",
  "textarea",
  "text_input",
  "time",
  "time_picker",
  "time_range_inline",
  "time_stacked",
  "timeline",
  "timestamp",
  "toggle",
  "tooltip",
  "typeahead",
  "user",
  "user_badge",
  "weekday_stacked"
];
